import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { DataService } from 'app/shared/services/dataService';

@Component({
  selector: 'app-pdmp',
  templateUrl: './pdmp.component.html',
  styleUrls: ['./pdmp.component.css']
})
export class PdmpComponent implements OnInit, OnChanges {
  @Input() caseId: string;
  @Input() showPdmp:boolean;
  pdmpData: any;
  loadingCount = 0;
  constructor(private dataService: DataService) { }

  ngOnInit() {
    if(this.showPdmp){
      this.getPDMP();
    }
  }

  ngOnChanges() {
    if(this.showPdmp){
      this.getPDMP();
    }
  }
  private getPDMP() {
    this.loadingCount ++;
    this.pdmpData = null;
    this.dataService.getPDMPData(this.caseId)
      .then(val => {
        this.pdmpData = val;
        this.loadingCount --;
      })
      .catch(() => { this.loadingCount --; });
  }

}
